import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import type { SRCatalogueKey } from '@/features/sponsored-recommendations/composables/useSendBidId';

import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSponsoredRecommendationsStore = defineStore('sponsoredRecommendations', () => {
	const catalogue = ref<Partial<Record<SRCatalogueKey, SponsoredAdFragment>>>({});

	function setSponsoredAd({ catalogueKey, ad }: { catalogueKey: SRCatalogueKey; ad: SponsoredAdFragment }) {
		catalogue.value[catalogueKey] = ad;
	}

	function clearSponsoredAd(catalogueKey: SRCatalogueKey) {
		delete catalogue.value[catalogueKey];
	}

	function clearAllSponsoredAds() {
		catalogue.value = {};
	}

	return {
		catalogue,
		setSponsoredAd,
		clearSponsoredAd,
		clearAllSponsoredAds,
	};
});
